<template>
  <div class="alert alert-info tag-filter-1">
    <p>تگ</p>
    <b-form-input
        @keypress.enter="submit"
        v-model="searchWords"
        placeholder="جستجو"
    ></b-form-input>
    <div class="" v-for="tag in tags ">

      <div class="form-check">
        <input v-model="selectedTags" class="form-check-input" type="checkbox" :value="tag.id" :id="`tag_${generateHash()}_${tag.id}`">
        <label class="form-check-label my-2 mr-3" :for="`tag_${generateHash()}_${tag.id}`">
          {{ tag.name }}
        </label>
      </div>

    </div>
  </div>
</template>


<script>
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";

export default {
  name: "TagFilter1",
  data() {
    return {
      tags: [],
      searchWords: '',
      selectedTags: []
    }
  },
  methods: {
    generateHash,
    async getTags() {
      let data = await this.$store.dispatch('Tag/getTags', {page: 1})
      data = data.data.data;
      this.tags = data.data
    },
    submit() {
      this.$store.commit('Tag/setFilters', {key: 'search', value: this.searchWords})
      this.getTags()
    }
  },
  mounted() {
    this.getTags();
  },
  watch: {
    selectedTags: {
      handler(oldValue, newValue) {
        this.$emit('updateFilter', {tags: this.selectedTags})
      }
    }
  },
}
</script>

<style scoped>
.tag-filter-1{
  height: 300px !important;
  overflow-y: auto;
}
</style>